import { makeStyles, alpha } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    actions: {
        color: theme.colors.text.mediumGray,
        [theme.breakpoints.up("md")]: {
            opacity: 0,
            transition: theme.transitions.create("opacity", {
                duration: 300,
                delay: 100,
                easing: "linear",
            }),
            "$body:hover &": {
                opacity: 1,
            },
        },
    },
    body: {
        cursor: "pointer",
        position: "relative",
        transition: theme.transitions.create("background-color", {
            duration: 300,
            easing: "linear",
        }),
        "&:hover": {
            backgroundColor: theme.colors.structure.pageBackground,
        },
    },
    bodyInactive: {
        opacity: 0.5,
    },
    dragHandleBtn: {
        minWidth: theme.spacing(3),
        width: theme.spacing(3),
        height: theme.spacing(4),
        padding: 0,
        position: "absolute",
        top: "50%",
        left: theme.spacing(0.5),
        transform: "translateY(-50%)",
        color: theme.colors.text.lightGray,
    },
    content: {
        flexGrow: 1,
    },
    icon: {
        transition: theme.transitions.create(["background-color", "color"], {
            duration: 300,
            delay: 100,
            easing: "linear",
        }),
        "$body:hover &": {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.colors.identity.teal, .1),
        },
    },
    inactiveIconContainer: {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        color: theme.colors.text.mediumGray,
        right: theme.spacing(4),
        transition: theme.transitions.create("opacity", {
            duration: 300,
            delay: 100,
            easing: "linear",
        }),
        "$body:hover &": {
            opacity: 0,
        },
    },
}), {
    name: "AdminListItem",
});

export default useStyles;